// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_sharing_invitation.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_planners_v1_resources_access_kind } from "./access_kind_pb.js";
import { file_studyo_today_planners_v1_resources_planner_relationship_kind } from "./planner_relationship_kind_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_sharing_invitation.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_sharing_invitation = /*@__PURE__*/
  fileDesc("CkNzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfc2hhcmluZ19pbnZpdGF0aW9uLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzIqkDChhQbGFubmVyU2hhcmluZ0ludml0YXRpb24SCgoCaWQYASABKAkSDAoEY29kZRgCIAEoCRJMChRyZWNlaXZlcl9hY2Nlc3Nfa2luZBgDIAEoDjIuLnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuQWNjZXNzS2luZBJfChpyZWNlaXZlcl9yZWxhdGlvbnNoaXBfa2luZBgEIAEoDjI7LnN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMuUGxhbm5lclJlbGF0aW9uc2hpcEtpbmQSLwoLaXNzdWVkX3RpbWUYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjMKD25vdF9iZWZvcmVfdGltZRgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMwoPZXhwaXJhdGlvbl90aW1lGAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIVCg1tYXhfdXNlX2NvdW50GAggASgFEhIKCnVzZWRfY291bnQYCSABKAVCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_planners_v1_resources_access_kind, file_studyo_today_planners_v1_resources_planner_relationship_kind]);

/**
 * Describes the message studyo.today.planners.v1.resources.PlannerSharingInvitation.
 * Use `create(PlannerSharingInvitationSchema)` to create a new message.
 */
export const PlannerSharingInvitationSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planner_sharing_invitation, 0);

